import InfoInput from './InfoInput'
export default InfoInput
